import { push } from 'react-router-redux';
import _ from 'lodash';
import ApiClient from '../utils/apiClient';
import { userConstants } from '../utils/types';
import routeConstants from '../utils/routeConstants';
import i18n from '../utils/i18n';
import { loginErrors, utmParams } from '../utils/constants';
import { routeToSignEndRoute } from './routingActions';
import { FullStoryAPI } from 'react-fullstory';

export const userUpdate = params => ({
  type: userConstants.UPDATE_USER,
  payload: {
    params
  }
});

export function getUserData(userData) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    if (auth.user && auth.user.token) {
      ApiClient.get('/api/v1/user/')
        .then(userResponse => {
          dispatch(userUpdate(userResponse.data));
        })
        .catch(error => {
          throw error;
        });
    }
  };
}

export function login(email, password) {
  const request = user => ({
    type: userConstants.LOGIN_REQUEST,
    payload: {
      user
    }
  });
  const success = user => ({
    type: userConstants.LOGIN_SUCCESS,
    payload: {
      user
    }
  });
  const failure = error => ({
    type: userConstants.LOGIN_FAILURE,
    payload: {
      error
    }
  });

  const initFullStory = userId =>
    FullStoryAPI('setUserVars', {
      displayName: `User ID:${userId}`,
      userId: userId,
      userDeuceId: userId
    });

  return dispatch => {
    dispatch(request({ email }));

    return ApiClient.post('/api/v1/login/', {
      username: email,
      password
    })
      .then(response => {
        const { token, user } = response.data;
        dispatch(success({ token }));
        initFullStory(user.id);
        return dispatch(userUpdate(user));
      })
      .then(() => dispatch(routeToSignEndRoute()))
      .catch(error => {
        if (error && error.response && error.response.data) {
          const errorType = error.response.data.error_type;
          if (errorType === loginErrors.LOGIN_NO_EMAIL_CONFIRMATION) {
            dispatch(push(routeConstants.NON_VERIFIED_EMAIL_ROUTE));
          } else if (errorType === loginErrors.LOGIN_NO_VERIFICATION) {
            dispatch(push(routeConstants.ADMIN_NON_VERIFIED_USER_ROUTE));
          } else {
            dispatch(
              failure(i18n.t('registerLoginScreens.WRONG_EMAIL_OR_PASS'))
            );
          }
        }
      });
  };
}

export function signOut() {
  FullStoryAPI('identify', false);
  return { type: userConstants.LOGOUT };
}

export function register(formData) {
  const request = user => ({
    type: userConstants.REGISTER_REQUEST,
    payload: {
      user
    }
  });
  const success = user => ({
    type: userConstants.REGISTER_SUCCESS,
    payload: {
      user
    }
  });
  const failure = error => ({
    type: userConstants.REGISTER_FAILURE,
    payload: {
      error
    }
  });

  return (dispatch, getState) => {
    const { utm } = getState().auth;
    const userData = {
      username: formData.email,
      password: formData.password,
      email: formData.email,
      first_name: formData.firstName,
      last_name: formData.lastName,
      accepted_terms_and_conditions: formData.termsAccepted,
      accepted_privacy_statement: formData.termsAccepted,
      gender: formData.gender,
      date_of_birth: formData.birthDate,
      postcode: formData.postcode,
      emergency_name: formData.emergency_name,
      emergency_phone_number: formData.emergency_phone_number,
      emergency_relationship: formData.emergency_relationship,
      emergency_existing_conditions: formData.emergency_existing_conditions,
      invite_hash: formData.invite_hash || null,
      ...utm
    };
    dispatch(request(userData));

    const endpoint = formData.invite_hash
      ? '/api/v1/complete-invited-user-registration/'
      : '/api/v1/register-user/';

    return ApiClient.post(endpoint, userData)
      .then(response => {
        dispatch(success(response));
        dispatch(login(formData.email, formData.password));
      })
      .catch(error => {
        let errorText = '';
        if (error.response) {
          const errorData = error.response.data;
          if (errorData) {
            errorText = i18n.t('SOMETHING_WENT_WRONG');
          }
        }
        dispatch(failure(errorText));
      });
  };
}

export function updateUser(params) {
  ApiClient.put('/api/v1/user/', params);
  return {
    type: userConstants.UPDATE_USER,
    payload: {
      params
    }
  };
}

export function updateUtm(params) {
  const properParams = _.pick(params, utmParams);
  return {
    type: userConstants.UPDATE_UTM,
    payload: {
      params: properParams
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/userActions.js